__turbopack_context__.v({
  "className": "league_spartan_31eb5b61-module__SXJJ6W__className",
  "variable": "league_spartan_31eb5b61-module__SXJJ6W__variable",
});
